module.exports = __webpack_public_path__ + "img/icon_74.4a3778f0.png";